import axios from 'axios';
import { BASE_URL, createRequest } from './httpClient';
import { getAdminHeaders } from './adminKeyService';

const getBase = () => BASE_URL || '';

const getAdminRequestConfig = (adminKey = '') => ({
    headers: getAdminHeaders(adminKey),
    withCredentials: false
});

export const getAdminSports = async (adminKey = '') => {
    return axios.get(`${getBase()}/admin/sports`, {
        ...getAdminRequestConfig(adminKey)
    });
};

export const getAdminUsers = async (adminKey = '') => {
    return axios.get(`${getBase()}/admin/users`, {
        ...getAdminRequestConfig(adminKey)
    });
};

export const updateAdminUserTier = async (userId, tier, adminKey = '') => {
    return axios.post(
        `${getBase()}/admin/users/tier/update`,
        { userId, currentTier: tier },
        getAdminRequestConfig(adminKey)
    );
};

export const updateAdminSport = async (sport, isActive, adminKey = '') => {
    return axios.post(
        `${getBase()}/admin/sports/update`,
        { sport, isActive },
        getAdminRequestConfig(adminKey)
    );
};

export const deleteAdminSport = async (sportId, adminKey = '') => {
    return axios.post(
        `${getBase()}/admin/sports/delete`,
        { sportId },
        getAdminRequestConfig(adminKey)
    );
};

export const postAdminAnalyticsEvents = async (events = [], adminKey = '') => {
    return axios.post(
        `${getBase()}/admin/analytics/events`,
        createRequest({ events }),
        getAdminRequestConfig(adminKey)
    );
};
